<template>
    <div class="modal-content">
        <div class="modal-header">
            <div class="game-header-content">
                <div class="game-bak-close-block">
                    <a @click="$emit('close-modal')" href="javascript:void(0);" data-bs-dismiss="modal"><img src="@/assets/images/back-arrow.svg" alt=""></a>
                    <strong>{{gameItem?.title}}</strong>
                </div>
                <div class="close-game-btn">
                    <a @click="$emit('close-modal')" href="javascript:void(0);" data-bs-dismiss="modal"><img src="@/assets/images/red-close-btn.svg" alt=""></a>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <div class="game-iframe-sec">
                <div v-if="this.iFrameUrl" class="iframe-content">
                    <iframe
                        :src="this.iFrameUrl"
                        frameborder="0"
                        style="overflow:hidden;overflow-x:hidden;overflow-y:hidden;height:100%;width:100%;position:absolute;top:0px;left:0px;right:0px;bottom:0px"
                        height="100%" width="100%" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
                        title="Tr&amp;eacute;ning TEXT"></iframe>
                </div>
            </div>
        </div>
    </div>

    <!-- Game Play Modal End -->
</template>
<script>
import { getGameItem } from '@/shared/constants/shared-data';
import api from '../services/api';
import * as apiName from '../services/urls';
import { AUTH_TOKEN } from '@/shared/constants/cookies-const';

export default {
    name: 'IFrameModal',
    emits:['close-modal'],
    data() {
        return {
            loading: false,
            iFrameUrl: null,
            gameItem:null
        }
    },
    mounted() {
        console.log("Game Item : ", this.getGameItemHere())
        this.gameItem = this.getGameItemHere();
        if(this.gameItem.provider=='poker')
        {
            this.getLivePockerUrl()
        }
        else 
        {
            this.getDreamCasinoLoadGames()
        }
    },
    methods: {
        getLivePockerUrl() {
            this.loading = true;
            let headers = {
                'Authorization': `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
            }
            api.post(apiName.GET_LIVE_POCKER_URL+this.gameItem.game_code+'?dtype=m',{},{headers}).then(response => {
                console.log("Result : ", response);
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        console.log("response", response);
                        this.iFrameUrl = response?.data?.data?.url;
                        //this.showSuccessModalFunc(response.data.message)
                        // this.closeModal();
                    }

                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                    this.showErrorModalFunc(error[0]);
                }
            });
        },

        getDreamCasinoLoadGames() {
            this.loading = true;
            let headers = {
                'Authorization': `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
            }
            api.post(apiName.DREAM_CASINO + this.gameItem.game_code + '/' + this.gameItem.sm_id, {}, { headers }).then(response => {
                console.log("Result : ", response);
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        console.log("response", response);
                        this.iFrameUrl = response?.data?.data?.url;
                        //this.showSuccessModalFunc(response.data.message)
                        // this.closeModal();
                    }

                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error);
                    this.showErrorModalFunc(error[0]);
                }
            });
        },

        getGameItemHere() {
            return getGameItem();
        },
        showErrorModalFunc(message) {
            this.$emit('error-modal', message);
        },
        showSuccessModalFunc(message) {
            this.$emit('success-modal', message);
        },
    }
}
</script>